import Header from "@/components/enfinity/our-solutions/enfinishield/Header";
import OurFeatures from "@/components/enfinity/our-solutions/enfinishield/OurFeatures";
import HowMuch from "@/components/enfinity/our-solutions/enfinishield/HowMuch";
import EveryPenny from "@/components/enfinity/our-solutions/enfinishield/EveryPenny";
import MediaCompanies from "@/components/enfinity/our-solutions/enfinishield/MediaCompanies";
import SimpleProcess from "@/components/enfinity/our-solutions/enfinishield/SimpleProcess";
import CTA from "@/components/enfinity/CTA";
import FAQ from "@/components/enfinity/Faq";
import Footer from "@/components/enfinity/Footer";
import { useEffect } from "react";

export default function EnfiniShield() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const shieldFaqs = [
    {
      question: "What happens when you find a copy?",
      answer:
        "We automatically file Content ID claims on unauthorized reuploads on YouTube. When eligible, views generated from your content can be monetized and recovered as revenue, allowing the value to return to you instead of content thieves.",
    },
    {
      question: "Do I need to do anything?",
      answer:
        "We handle everything for you. Once your content is set up and you whitelist the channels you want to protect, everything runs automatically. Our system detects matching uploads, files Content ID claims, and manages rights enforcement on your behalf.",
    },
    {
      question: "How much can I recover?",
      answer:
        "Recovery depends on how often your content is reuploaded and how those videos perform. Some creators recover less, while others recover much more from eligible reuploads through Content ID claims.",
    },
    {
      question: "What if someone disputes my claim?",
      answer:
        "We handle disputes on your behalf. Our team reviews the dispute, provides evidence of your ownership, and manages the resolution process through YouTube's Content ID system. In most cases, disputes are resolved in your favor as the rightful content owner.",
    },
  ];

  return (
    <div className="bg-[#111111]">
      <Header />

      <OurFeatures />

      <HowMuch />

      <EveryPenny />

      <MediaCompanies />

      <SimpleProcess />

      <div>
        <CTA />
      </div>

      <div className="min-h-[900px] bg-white lg:pb-36 xxs:pb-60">
        <FAQ faqs={shieldFaqs} />
      </div>

      <Footer />
    </div>
  );
}

